import { Spin } from "antd";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
const GenerateStatus = ({ dashboardEdit }) => {
  return (
    <div
      className="position-absolute generate--status"
      style={dashboardEdit ? { bottom: "7rem" } : {}}
    >
      <Spin
        className="testing"
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 24,
              color: "var(--locobuzz-btn-active-text-color,--color-white)",
            }}
            spin
          />
        }
      />

      <div className="generate--label">
        <div className="fontSize-14 font-weight500">
          Generating Your Chart...
        </div>
        <div className="fontSize-12 mt-1">Please wait for some time.</div>
      </div>
    </div>
  );
};

export default GenerateStatus;
